var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Good_icon",
    "data-name": "Good icon",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M200.5,388h14.359a.141.141,0,0,1,.141.141V402.5A14.5,14.5,0,0,1,200.5,417h0A14.5,14.5,0,0,1,186,402.5h0A14.5,14.5,0,0,1,200.5,388Z",
    transform: "translate(-186 -388)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(5.999 6.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M215.05,398.8h-1.487c0-.3-.647-.744-1.54-.744s-1.54.445-1.54.744H209c0-1.251,1.33-2.231,3.027-2.231S215.05,397.546,215.05,398.8Z",
    transform: "translate(-197.895 -396.567)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M202.99,416.234a8.933,8.933,0,0,1-8.923-8.923v-.744h17.846v.744A8.933,8.933,0,0,1,202.99,416.234Zm-7.4-8.18a7.436,7.436,0,0,0,14.8,0Z",
    transform: "translate(-194.067 -399.131)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M201.05,398.8h-1.487c0-.3-.647-.744-1.54-.744s-1.54.445-1.54.744H195c0-1.251,1.33-2.231,3.027-2.231S201.05,397.546,201.05,398.8Z",
    transform: "translate(-194.305 -396.567)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodFace);
export default __webpack_public_path__ + "static/media/goodFace.c73aa2d730664a02cb5676aedb6a909b.svg";
export { ForwardRef as ReactComponent };